var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.activeSearch
    ? _c(
        "div",
        { staticClass: "listing", attrs: { id: "popupComplete" } },
        [
          _c("popup-product", { attrs: { item: _vm.addProduct } }),
          _vm._v(" "),
          !_vm.loading
            ? _c("div", { staticClass: "flex-block" }, [
                _vm.arResult.ITEMS
                  ? _c("div", { staticClass: "sections-search" }, [
                      _c(
                        "ul",
                        _vm._l(_vm.sections, function (section) {
                          return _c(
                            "li",
                            {
                              staticClass: "section-complete",
                              class: {
                                active: section.ID == _vm.activeCategoryId,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setActiveSection(section)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(section.NAME) +
                                  " (" +
                                  _vm._s(section.productCount) +
                                  ")\n                "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.arResult.ITEMS
                  ? _c(
                      "div",
                      {
                        staticClass: "just-sp-btw list-products",
                        attrs: { id: "sc-bot" },
                      },
                      _vm._l(_vm.filtredProducts, function (item) {
                        return _c(
                          "div",
                          {
                            key: item.ID,
                            staticClass: "shops-bor-cart",
                            style: { width: _vm.countLine + "%" },
                          },
                          [
                            _c("listing-card", {
                              attrs: { item: item },
                              on: { "add-product": _vm.addProductHandler },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xl-12" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "loader",
                },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.allParams.pathTheme + "/images/loader.gif",
                      alt: "",
                    },
                  }),
                ]
              ),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }